/**
 * @desc Web returns a boolean, mobile returns boolean on hasFirstAvailable
 */
export function hasFirstAvailable(payload: boolean | { hasFirstAvailable: boolean }) {
  return typeof payload === 'boolean' ? payload : payload?.hasFirstAvailable;
}
